import script from "./AdminAnnouncementDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAnnouncementDetail.vue?vue&type=script&setup=true&lang=js"

import "./AdminAnnouncementDetail.vue?vue&type=style&index=0&id=769f9cb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-769f9cb2"]])

export default __exports__